import { statusColors } from "./colors";
import { BASE_REPORT_URL, BASE_URL } from "../apis/apiConstants";
import { tViews, tUtils } from "../utils/table";

export const IS_PRODUCTION = process.env.NODE_ENV === "production";

export const SITE = {
  CUSTOM: "custom-sites",
  get CUSTOM_SITES() { return tUtils('enumsCustomSites')},
  ALL: "all-sites",
  get ALL_SITES() { return tUtils('enumsAllSites')},
  TYPE: "site"
};

export const isSpecificSiteSelection = (siteIds) => {
  return Array.isArray(siteIds) && siteIds.length > 0 && siteIds[0] !== "all";
};

export const APP = {
  CUSTOM: "custom-application",
  get CUSTOM_APP() { return tUtils('enumsCustomSites')},
  ALL: "all-application",
  get ALL_APPS() { return tUtils('enumsAllApplications')},
};

export const BannerTypes = {
  LOADING: "loading",
  ERROR: "error"
};

export const filter = {
  apps: {
    table_filter: { vqoe_status: ["good", "fair", "poor"] },
    sort: { vqoe_score: "asc" },
    size: 5,
    offset: 0
  },
  sites: {
    sort: { up_percent: "asc" },
    size: 5,
    offset: 0
  }
};

export const usageFilter = {
  sort: {
    usage: "desc"
  },
  offset: 0,
  size: 20
};

export const filterAppExperience = {
  ...usageFilter,
  table_filter: {
    vqoe_status: ["poor", "fair", "good"]
  }
};

export const FORMAT_PAGE_NAME = {
  EXECUTIVE: "executive_summary",
  ALL_APPLICATIONS: "application_summary",
  ALL_SITES: "site_summary",
  APP_360: "app_360",
  SITE_360: "site_360",
  LINK_SLA: "link_sla",
  LINK_UTILIZATION: "link_utilization",
  LINK_AVAILABILITY: "link_availability",
  LINK_SUMMARY: "link_summary",
  TOP_CLIENTS: "clients_summary"
};

export const FORMAT_CSV_PAGE_NAME = {
  ALL_APPLICATIONS: "all_apps_csv",
  ALL_SITES: "all_sites_csv",
  APP_360: "app360_csv",
  LINK_SLA: "link_sla_csv",
  LINK_UTILIZATION: "link_utilization_csv",
  LINK_AVAILABILITY: "link_availability_csv",
  LINK_SUMMARY: "link_summary_csv",
  CLIENTS_SUMMARY: "clients_summary_csv"
};

export const PAGE_NAME = {
  EXECUTIVE: "Executive Summary",
  ALL_APPLICATIONS: "Application Summary",
  ALL_SITES: "All Sites",
  APP_360: "App 360",
  SITE_360: "Site 360",
  LINK_SLA: "Link SLA",
  LINK_UTILIZATION: "Link Utilization",
  LINK_AVAILABILITY: "Link Availability",
  LINK_SUMMARY: "Link Summary",
  TOP_CLIENTS: "Clients Summary"
};

export const SCHEDULE_FREQUENCY = {
  NOW: "now",
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly"
};

export const SCHEDULE_TYPE = {
  ONCE: "once",
  RECURRING: "recurring",
};

export const TEMPLATE_NAME = {
  [PAGE_NAME.EXECUTIVE]: "executive_summary",
  [PAGE_NAME.ALL_APPLICATIONS]: "application_experience",
  [PAGE_NAME.ALL_SITES]: "site_experience",
  [PAGE_NAME.APP_360]: "app_360",
  [PAGE_NAME.SITE_360]: "site_360",
  [PAGE_NAME.LINK_SLA]: "link_sla",
  [PAGE_NAME.LINK_UTILIZATION]: "link_utilization",
  [PAGE_NAME.LINK_AVAILABILITY]: "link_availability",
  [PAGE_NAME.LINK_SUMMARY]: "link_summary",
  [PAGE_NAME.TOP_CLIENTS]: "top_clients",
};

export const regexEmail = /^(([^<>()[\]\\.,;|:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const regexName = /^[0-9A-Za-z_.-]+$/;

export const initGlobalState = {
  step: 1,
  isNextDisabled: true,
  repeatTime: "",
  repeatOn: 1
};

// Regex can validate domain names - Host name with range from (3-61)
//eslint-disable-next-line
export const regexDomains = /^(?:(?:(?:[a-zA-z\-]+)\:\/{1,3})?(?:[a-zA-Z0-9])(?:[a-zA-Z0-9\-\.]){1,61}(?:\.[a-zA-Z]{2,})+|\[(?:(?:(?:[a-fA-F0-9]){1,4})(?::(?:[a-fA-F0-9]){1,4}){7}|::1|::)\]|(?:(?:[0-9]{1,3})(?:\.[0-9]{1,3}){3}))(?:\:[0-9]{1,5})?$/;

export const SWITCH = {
  OVERVIEW: {
    ACTION: "site/SET_OVERVIEW",
    get LABEL() { return tUtils('commonUtilOverview'); }
  },
  TOP_SITES: { ACTION: "site/SET_TOP_SITES" }
};

export const TOGGLER = {
  MAP: "map",
  LIST: "list",
  CARD: "cards",
  CHART: "chart",
  AVAILABILITY: "availability",
  RECOMMENDATION: "recommendation"
};

export const EXPERIENCE_COLORS = {
  GOOD: statusColors.good, //OK
  FAIR: statusColors.fair, //WAITING
  POOR: statusColors.danger, //DOWN
  NA: statusColors.gray,
  GRAY: statusColors.gray,
  UNKNOWN: statusColors.gray, //DOWN
  READY: statusColors.good,
  DELETED: statusColors.black,
  NOCHANGE: statusColors.gray
};
export const ACTIONSTATE = {
  NON_APPLIED: "NON_APPLIED",
  APPLY_REQUEST: "APPLY_REQUEST",
  APPLIED: "APPLIED",
  REVERT_REQUEST: "REVERT_REQUEST",
  DELETED: "DELETED",
  STALE: "STALE",
  READY: "READY",
  NOCHANGE: "NOCHANGE",
  ALL: "ALL",
  APPLY: "Apply",
  REVERT: "Revert"
};

export const IDP_ACTIONS = {
  DEFINE: "Define IDP",
  VIEW: "View IDP",
  DELETE: "Delete IDP",
  EDIT: "Edit IDP",
  ACTIVATE: "Activate",
  DEACTIVATE: "Deactivate"
};

export const CUSTOM_MAKER = {
  CIRCLE: "CIRCLE",
  TRAY: "TRAY"
};

export const initialFilterArray = ["Low", "Fair", "High", "Unknown"];

export const qoeFilterArray = ['good', 'fair', 'poor', 'unknown'];

export const siteFilter = {
  sort: {
    site_name: "asc"
  },
  offset: 0,
  size: 50
};
//i.e.  "red" is used to define the class in the style.less=> qoe-red or qoe-black className
export const COLOR = {
  RED: "red",
  BLUE: "blue",
  GREEN: "green",
  BLACK: "black",
  GRAY: "gray",
  FAIR: "fair",
  GOOD: "good",
  POOR: "poor",
  UNKNOWN: "unknown"
};

/**
 * Beta flag tracking wiki https://wiki.cisco.com/display/VANALYTICS/Beta+Feature+Flags
 */
export const FEATURE_CONFIG = {
  AD: {
    isBeta: new Date() < new Date(2025, 7, 31), //Sun Aug 31 2025
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2025, 7, 31)
  },
  ADUSAGE: {
    isBeta: new Date() < new Date(2025, 12, 31), //Tue Dec 31 2025
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2025, 12, 31)
  },
  TIMEFILTER: {
    isBeta: new Date() < new Date(2024, 11, 6),
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2024, 11, 6)
  },
  LOGS: {
    isBeta: new Date() < new Date(2025, 7, 31), //Sun Aug 31 2025
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2025, 7, 31)
  },
  LINKSLA: {
    isBeta: new Date() < new Date(2025, 7, 31), //Sun Aug 31 2025
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2025, 7, 31)
  },
  LINKUTILIZATION: {
    isBeta: new Date() < new Date(2025, 7, 31), //Sun Aug 31 2025
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2025, 7, 31)
  },
  LINK_AVAILABILITY: {
    isBeta: new Date() < new Date(2025, 8, 30), //Tue Sep 30 2025
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2025, 8, 30)
  },
  LINK_SUMMARY: {
    isBeta: new Date() < new Date(2025, 8, 30), //Tue Sep 30 2025
    betaMessage: "Beta Version.",
    startDate: new Date(),
    endDate: new Date(2025, 8, 30)
  }
};
/**
 * Feature highlight expiration date https://wiki.cisco.com/display/VANALYTICS/Feature+Highlight+Flags
 */
export const FEATURE_HIGHLIGHT_CONFIG = {
  TRAFFIC_LOGS_TREE: {
    get description() { return tUtils('commonUtilFirewallRuleFilter'); },
    featureHighlightName: 'vAnalytics_traffic_logs_advanced_filtering',
    isEnabled: new Date() < new Date(2025, 7, 15), //August 15 2025
  }
};

export const APPCLASS = {
  VOICE: "voice",
  WEBEX: "webex",
  OFFICE365: "office365",
  SALESFORCE: "salesforce",
  GOOGLE: "google-workspace",
  GOTOMEETING: "gotomeeting"
};

export const defaultTextValue = "--";

export const defaultCellValue = "-";

export const customTimeFilterText = "Custom";

// '●' - circle character's character code is 9679
export const charCircle = String.fromCharCode(9679);
export const charRect = String.fromCharCode(0x25AC);
export const charSq = "&#x25A0";
export const marker = `-${String.fromCharCode(0x2022)}-`;
export const dashedLineChar = "--"; // Dashed line

export const AVAILABILITY_STATUS = {
  ALL: "all",
  HIGH: "high",
  FAIR: "fair",
  LOW: "low",
  NA: "unknown"
};

export const timeFilterTypes = {
  "1": "1h",
  "3": "3h",
  "6": "6h",
  "12": "12h",
  "24": "24h",
  "168": "7d",
  "720": "30d",
  "Custom": "CUSTOM",
  "daily": "24h",
  "weekly": "7d",
  "monthly": "30d"
};

export const fields = [
  "site_id",
  "application",
  "vqoe_status",
  "vqoe_score",
  "vqoe_change",
  "usage",
  "packet_loss",
  "latency",
  "jitter",
  "site_name",
  "city",
  "latitude",
  "longitude",
  "application_class"
];

export const tLocState = {
  adminDown: "admin-down",
  unknown: "unknown",
  operDown: "oper-down",
  operUp: "oper-up"
};

export const webexGroup = "webex-group";

export const timeFilterTypesCustomV4 = {
  "1": "1h",
  "3": "3h",
  "6": "6h",
  "12": "12h",
  "24": "24h",
  "168": "7d",
  "720": "30d",
  "Custom": "custom",
  "daily": "24h",
  "weekly": "7d",
  "monthly": "30d"
};

// IEC standard decimal byte units
// reference: https://www.iec.ch/prefixes-binary-multiples
// unit reference: https://www.electropedia.org/iev/iev.nsf/display?openform&ievref=171-02-13
export const byteDecimalUnits =
  ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

// protocol number and keyword pair
export const protocols = {
  0: "HOPOPT",
  1: "ICMP",
  2: "IGMP",
  3: "GGP",
  4: "IPv4",
  5: "ST",
  6: "TCP",
  7: "CBT",
  8: "EGP",
  9: "IGP",
  10: "BBN-RCC-MON",
  11: "NVP-II",
  12: "PUP",
  13: "ARGUS",
  14: "EMCON",
  15: "XNET",
  16: "CHAOS",
  17: "UDP",
  18: "MUX",
  19: "DCN-MEAS",
  20: "HMP",
  21: "PRM",
  22: "XNS-IDP",
  23: "TRUNK-1",
  24: "TRUNK-2",
  25: "LEAF-1",
  26: "LEAF-2",
  27: "RDP",
  28: "IRTP",
  29: "ISO-TP4",
  30: "NETBLT",
  31: "MFE-NSP",
  32: "MERIT-INP",
  33: "DCCP",
  34: "3PC",
  35: "IDPR",
  36: "XTP",
  37: "DDP",
  38: "IDPR-CMTP",
  39: "TP++",
  40: "IL",
  41: "IPv6",
  42: "SDRP",
  43: "IPv6-Route",
  44: "IPv6-Frag",
  45: "IDRP",
  46: "RSVP",
  47: "GRE",
  48: "DSR",
  49: "BNA",
  50: "ESP",
  51: "AH",
  52: "I-NLSP",
  53: "SWIPE",
  54: "NARP",
  55: "MOBILE",
  56: "TLSP",
  57: "SKIP",
  58: "IPv6-ICMP",
  59: "IPv6-NoNxt",
  60: "IPv6-Opts",
  61: "Internal",
  62: "CFTP",
  63: "Local",
  64: "SAT-EXPAK",
  65: "KRYPTOLAN",
  66: "RVD",
  67: "IPPC",
  68: "Distributed File System",
  69: "SAT-MON",
  70: "VISA",
  71: "IPCV",
  72: "CPNX",
  73: "CPHB",
  74: "WSN",
  75: "PVP",
  76: "BR-SAT-MON",
  77: "SUN-ND",
  78: "WB-MON",
  79: "WB-EXPAK",
  80: "ISO-IP",
  81: "VMTP",
  82: "SECURE-VMTP",
  83: "VINES",
  84: "TTP / IPTM",
  85: "NSFNET-IGP",
  86: "DGP",
  87: "TCF",
  88: "EIGRP",
  89: "OSPFIGP",
  90: "Sprite-RPC",
  91: "LARP",
  92: "MTP",
  93: "AX.25",
  94: "IPIP",
  95: "MICP",
  96: "SCC-SP",
  97: "ETHERIP",
  98: "ENCAP",
  99: "Private",
  100: "GMTP",
  101: "IFMP",
  102: "PNNI",
  103: "PIM",
  104: "ARIS",
  105: "SCPS",
  106: "QNX",
  107: "A/N",
  108: "IPComp",
  109: "SNP",
  110: "Compaq-Peer",
  111: "IPX-in-IP",
  112: "VRRP",
  113: "PGM",
  114: "0-hop",
  115: "L2TP",
  116: "DDX",
  117: "IATP",
  118: "STP",
  119: "SRP",
  120: "UTI",
  121: "SMP",
  122: "SM",
  123: "PTP",
  124: "ISIS over IPv4",
  125: "FIRE",
  126: "CRTP",
  127: "CRUDP",
  128: "SSCOPMCE",
  129: "IPLT",
  130: "SPS",
  131: "PIPE",
  132: "SCTP",
  133: "FC",
  134: "RSVP-E2E-IGNORE",
  135: "Mobility Header",
  136: "UDPLite",
  137: "MPLS-in-IP",
  138: "manet",
  139: "HIP",
  140: "Shim6",
  141: "WESP",
  142: "ROHC",
  143: "Ethernet",
  144: "AGGFRAG",
  145: "Unassigned",
  146: "Unassigned",
  147: "Unassigned",
  148: "Unassigned",
  149: "Unassigned",
  150: "Unassigned",
  151: "Unassigned",
  152: "Unassigned",
  153: "Unassigned",
  154: "Unassigned",
  155: "Unassigned",
  156: "Unassigned",
  157: "Unassigned",
  158: "Unassigned",
  159: "Unassigned",
  160: "Unassigned",
  161: "Unassigned",
  162: "Unassigned",
  163: "Unassigned",
  164: "Unassigned",
  165: "Unassigned",
  166: "Unassigned",
  167: "Unassigned",
  168: "Unassigned",
  169: "Unassigned",
  170: "Unassigned",
  171: "Unassigned",
  172: "Unassigned",
  173: "Unassigned",
  174: "Unassigned",
  175: "Unassigned",
  176: "Unassigned",
  177: "Unassigned",
  178: "Unassigned",
  179: "Unassigned",
  180: "Unassigned",
  181: "Unassigned",
  182: "Unassigned",
  183: "Unassigned",
  184: "Unassigned",
  185: "Unassigned",
  186: "Unassigned",
  187: "Unassigned",
  188: "Unassigned",
  189: "Unassigned",
  190: "Unassigned",
  191: "Unassigned",
  192: "Unassigned",
  193: "Unassigned",
  194: "Unassigned",
  195: "Unassigned",
  196: "Unassigned",
  197: "Unassigned",
  198: "Unassigned",
  199: "Unassigned",
  200: "Unassigned",
  201: "Unassigned",
  202: "Unassigned",
  203: "Unassigned",
  204: "Unassigned",
  205: "Unassigned",
  206: "Unassigned",
  207: "Unassigned",
  208: "Unassigned",
  209: "Unassigned",
  210: "Unassigned",
  211: "Unassigned",
  212: "Unassigned",
  213: "Unassigned",
  214: "Unassigned",
  215: "Unassigned",
  216: "Unassigned",
  217: "Unassigned",
  218: "Unassigned",
  219: "Unassigned",
  220: "Unassigned",
  221: "Unassigned",
  222: "Unassigned",
  223: "Unassigned",
  224: "Unassigned",
  225: "Unassigned",
  226: "Unassigned",
  227: "Unassigned",
  228: "Unassigned",
  229: "Unassigned",
  230: "Unassigned",
  231: "Unassigned",
  232: "Unassigned",
  233: "Unassigned",
  234: "Unassigned",
  235: "Unassigned",
  236: "Unassigned",
  237: "Unassigned",
  238: "Unassigned",
  239: "Unassigned",
  240: "Unassigned",
  241: "Unassigned",
  242: "Unassigned",
  243: "Unassigned",
  244: "Unassigned",
  245: "Unassigned",
  246: "Unassigned",
  247: "Unassigned",
  248: "Unassigned",
  249: "Unassigned",
  250: "Unassigned",
  251: "Unassigned",
  252: "Unassigned",
  253: "Testing",
  254: "Testing",
  255: "Reserved"
};

export const timeFilters5m = [
  timeFilterTypesCustomV4["1"],
  timeFilterTypesCustomV4["3"],
  timeFilterTypesCustomV4["6"]
];

export const timeMS = { min5: 300000, hour1: 3600000 };

// feature keys
export const features = {
  bwf: "bwf", // bandwidth forecasting tab
  ad: "ad", // anomaly detections tab
  adUsage: "ad-usage", // anomaly detections usage tab
  // threat intelligence page
  ti: "security",
  ppr: "wani", // predictive path network
  // application 360 at single site - app flows tab - path trace sidebar
  umts: "umts",
  // application 360 at single site - path analytics tab
  pa: "webex",
  // time filter options
  days1: "24h",
  days7: "7d",
  days30: "30d",
  custom: "custom",
  logs: "oda-traffic-logs",
  insights: "insights",
  appqoe: "appqoe", // App QoE optimization feature tab
  genaiExplain: "genai-widget-explain",
  appFlowAarCorrelation: "app_flow_aar_correlation", // App Flow AAR Correlation feature
  nwpiReadout: "nwpi-readout" // NWPI Readout feature
};

export const adUrls = {
  pn: "/predictivenetworks",
  ad: "/anomalydetection"
}

// route urls
export const routeURLs = {
  login: "/login",
  accounts: "/accounts",
  overview: "/overview",
  sites: "/sites",
  applications: "/applications",
  app360: "/dashboards/:appName",
  circuits: "/circuits",
  circuit360: "/circuits/:circuitName",
  notFound: "/notfound",
  pn: "/predictivenetworks",
  bwf: "/predictivenetworks/bandwidthforecasting",
  appInfoAtSite: "/predictivenetworks/applicationinformation/site",
  appInfoPathMetric: "/predictivenetworks/applicationinformation/device",
  ad: "/predictivenetworks/anomalydetection",
  adNew: "/predictivenetworks/anomalydetection",
  adSingleSite: "/predictivenetworks/anomalydetection/:siteName",
  adSingleSiteTrend: "/predictivenetworks/anomalydetection/:siteName/:tunnelName",
  threatIntelligence: "/threatintelligence",
  trafficLogs: "/traffic-logs",
  optimization: "/optimization",
  appQoeDetails: "/optimization/appqoe-details",
  reports: "/reports",
  reportOverview: `${BASE_REPORT_URL}:id/executive_summary`,
  reportSites: `${BASE_REPORT_URL}:id/site_summary`,
  reportApps: `${BASE_REPORT_URL}:id/application_summary`,
  reportApp360: `${BASE_REPORT_URL}:id/application_summary/:appName`,
  reportLinkSLA: `${BASE_REPORT_URL}:id/link_sla`,
  reportLinkUtilization: `${BASE_REPORT_URL}:id/link_utilization`,
  reportLinkAvailability: `${BASE_REPORT_URL}:id/link_availability`,
  reportTopClients: `${BASE_REPORT_URL}:id/clients_summary`
};
for (const key in routeURLs) routeURLs[key] = `${BASE_URL}${routeURLs[key]}`;

export const reportURLGeneratedReportsTab = `${routeURLs.reports}#generated-reports`;
export const reportURLReportTemplatesTab = `${routeURLs.reports}#report-templates`;

export const msHours1 = 1 * 60 * 60 * 1000;

export const defaultDateFormat = "MMM dd, yyyy hh:mm aa";
export const utcDateFormat = "yyyy-MM-dd HH:mm:ss";
export const utcDateFormatFull = "MMM dd, yyyy hh:mm aa";

// MFE (Micro Frontend) Configuration
export const MFE_API_BASE_URL = `https://${process.env.REACT_APP_CDN_URL}`;
export const MFE_CONVERGED_ONPREM_CONFIG_URL = `/assets/mfe/unified-ui-config/latest.json`;
export const MFE_UNIFIED_CONFIG_URL = `${MFE_API_BASE_URL}/unified-ui-config/latest.json`;

// Version Thresholds for On-Prem/Convergence Features
export const VERSION_THRESHOLDS = Object.freeze({
  MIN_ONPREM_MFE: 26.2,
  MIN_DARK_THEME: 27.1,
});

export const MFE_IDS = Object.freeze({
  CIRCUIT: "cisco.sdwan.app.tab.circuit",
  OPTIMIZATION: "cisco.sdwan.app.tab.optimization",
  STATE: "cisco.sdwan.app.global-state-manager",
  APPLICATION: "cisco.sdwan.app.tab.application",
  THREAT_INTELLIGENCE: "cisco.sdwan.app.tab.threatintelligence",
  TRAFFIC_LOGS: "cisco.sdwan.app.tab.trafficlogs",
  BANDWIDTH_FORECAST: "cisco.sdwan.app.tab.bandwidthforecast",
});

// MFE UI Component IDs
export const MFE_COMPONENT_IDS = Object.freeze({
  CIRCUITS: `${MFE_IDS.CIRCUIT}/circuits`,
  CIRCUIT_360: `${MFE_IDS.CIRCUIT}/circuit360`,
  APPLICATIONS: `${MFE_IDS.APPLICATION}/applications`,
  APPLICATION_360: `${MFE_IDS.APPLICATION}/application360`,
  THREAT_INTELLIGENCE: `${MFE_IDS.THREAT_INTELLIGENCE}/threat_intelligence`,
  OPTIMIZATION: `${MFE_IDS.OPTIMIZATION}/optimization`,
  APP_QOE_DETAILS: `${MFE_IDS.OPTIMIZATION}/appQoeDetails`,
  TRAFFIC_LOGS: `${MFE_IDS.TRAFFIC_LOGS}/trafficLogs`,
  BANDWIDTH_FORECAST: `${MFE_IDS.BANDWIDTH_FORECAST}/bandwidthForecast`,
});

// Anchor Runtime Property IDs
export const ANCHOR_PROPERTY_IDS = Object.freeze({
  FABRIC: `${MFE_IDS.STATE}/selectedOverlay`,
  TIME_PERIOD: `${MFE_IDS.STATE}/timePeriodSelected`,
  TIME_RANGE: `${MFE_IDS.STATE}/timeFilter`,
  CUSTOM_TIME: `${MFE_IDS.STATE}/selectedCustomTime`,
  SITE: `${MFE_IDS.STATE}/selectedSite`,
  NETWORK_HIERARCHY_NAME: `${MFE_IDS.STATE}/selectedNetworkHierarchyName`,
  TIMESTAMP: `${MFE_IDS.STATE}/currentTimeStamp`,
  SITES: `${MFE_IDS.STATE}/sites`,
  CIRCUITS_MASTER_TABLE: `${MFE_IDS.STATE}/circuitsMasterTable`,
  FEATURES: `${MFE_IDS.STATE}/features`,
  SYNC_WITH_MFE_STATE: `${MFE_IDS.STATE}/syncWithMFEState`,
  TOGGLE_VIEW: `${MFE_IDS.STATE}/toggleView`,
  REMOTE_SELECTED_SITE: `${MFE_IDS.APPLICATION}/selectedRemoteSite`,
  APP_FAMILY_SLA: `${MFE_IDS.APPLICATION}/app_data_with_family_sla`,
  APP_FLOW_TABLE_TIME: `${MFE_IDS.APPLICATION}/appFlowTableTime`,
});

// Anchor Runtime Command IDs
export const ANCHOR_COMMAND_IDS = Object.freeze({
  FABRIC: `${MFE_IDS.STATE}/setSelectedOverlay`,
  TIME_PERIOD: `${MFE_IDS.STATE}/setTimePeriodSelected`,
  TIME_RANGE: `${MFE_IDS.STATE}/setTimeFilter`,
  CUSTOM_TIME: `${MFE_IDS.STATE}/setSelectedCustomTime`,
  SITE: `${MFE_IDS.STATE}/setSelectedSite`,
  NETWORK_HIERARCHY_NAME: `${MFE_IDS.STATE}/setSelectedNetworkHierarchyName`,
  TIMESTAMP: `${MFE_IDS.STATE}/setCurrentTimeStamp`,
  SITES: `${MFE_IDS.STATE}/setSites`,
  FEATURES: `${MFE_IDS.STATE}/setFeatures`,
  TOGGLE_VIEW: `${MFE_IDS.APPLICATION}/setPageToggle`,
  SITE_API_DATA: `${MFE_IDS.STATE}/setSitesTableAvailability`,
  REMOTE_SELECTED_SITE: `${MFE_IDS.APPLICATION}/setSelectedRemoteSite`
});

export const DateValidationMessages = {
  EMPTY_START_END_DATES: "dateValidationMessages.emptyStartEndDates",
  START_DATE_AFTER_END_DATE: "dateValidationMessages.startDateAfterEndDate",
  SAME_DATE_INCOMPATIBLE_TIMES: "dateValidationMessages.sameDateIncompatibleTimes",
  INSUFFICIENT_TIME_RANGE: "dateValidationMessages.insufficientTimeRange",
  TIME_RANGE_EXCEEDED: "dateValidationMessages.timeRangeExceeded",
  CALENDAR_ADJUSTMENTS: "dateValidationMessages.calendarAdjustments",
  DEFAULT_SELECTION: "dateValidationMessages.defaultSelection",
  INVALID_DATE_FORMAT: "dateValidationMessages.invalidDateFormat",
  PAST_DATE_SELECTION: "dateValidationMessages.pastDateSelection",
  FUTURE_DATE_SELECTION: "dateValidationMessages.futureDateSelection",
  OVERLAPPING_DATE_RANGE: "dateValidationMessages.overlappingDateRange"
};

/**
 * Export csv labels for various charts.
 */
export const EXPORT_CSV_LABELS = {
  APPLICATIONS: "Applications",
  CIRCUITS: "Circuits",
  CIRCUITS360: "Circuits360",
  // Applications
  APPLICATIONS_QOE: "Applications_QoE",
  APPLICATIONS_USAGE_TOTAL: "Applications_Usage_Total",
  APPLICATIONS_TOP20_USAGE: "Applications_Top20_Usage",
  APPLICATIONS_QOE_DISTRIBUTION: "Applications_QoE_Distribution",
  // trend analysis
  APPLICATIONS_COUNT_BY_QOE: "Applications_Count_By_QoE",
  TOTAL_USAGE: "Applications_Total_Usage",
  QOE_APPLICATIONS: "Applications_QoE",
  APPLICATIONS_USAGE: "Applications_Usage",
  //Circuits
  get CIRCUITS_USAGE() { return tViews('circuitsUsage')},
  get CIRCUITS_COLOR_USAGE() { return tViews('circuitsColorUsage')},
  get CIRCUITS_BANDWIDTH() { return tViews('circuitsBandwidth')},
  //Circuits360
  get CIRCUITS360_APPLICATIONS_USAGE() { return tViews('circuit360ApplicationsUsage')},
  get CIRCUITS360_USAGE() { return tViews('circuits360Usage')},
  get CIRCUITS360_BANDWIDTH() { return tViews('circuits360Bandwidth')},
  get CIRCUITS360_TUNNEL_USAGE() { return tViews('circuits360TunnelUsage')},
  // Predictive Networks
  get PN_USEREXPERIENCE_CHART() { return tViews('circuserExperienceChartuitsUsage')},
  PN_SITE_LOADBALANCE: "PredictiveNetworks_Site_LoadBalance",
  PN_PATH_RECOMMENDATIONS: "PredictiveNetworks_Path_Recommendations",
  //AD
  get AD_CELLULAR_USAGE() { return tViews('adCellularUsage')},
  get AD_CIRCUITS_AVAILABILITY() { return tViews('adCircuitsAvailability')},
  get AD_SUMMARY() { return tViews('adSummary')},
  get "app-usage-trend-chart"() { return tViews('adAppUsageTrend')},
  get "circuit-usage-trend-chart"() { return tViews('adCircuitUsageTrend')},
  get "circuit-usage"() { return tViews('adCellularInterfaceUsage')},
  get QOE_CIRCUITS() { return tViews('qoeCircuits')},
};

export const LOCAL_STORAGE_LABELS = {
  TRAFFIC_LOGS: "tblsettings_trafficlogs",
  RECOMMENDATION_TABLE: "tblsettings_recommendation",
  PATHDEVICEPAIR_TABLE: "tblsettings_pathdevicepair",
  APPLICATION_TABLE: "tblsettings_applications",
  REPORT_TABLE: "tblsettings_reports",
  AD_USAGE_APPLICATION_TABLE: "tblsettings_ad_usage_applications",
  AD_USAGE_ANOMALY_SUMMARY_TABLE: "tblsettings_ad_usage_anomaly_summary",
  AD_SITES_TABLE: "tblsettings_ad_sites",
  AD_SINGLE_SITE_TABLE: "tblsettings_ad_single_site",
  AD_USAGE_CIRCUITS_AVAILABILITY_TABLE: "tblsettings_ad_usage_circuits_availability",
  AD_USAGE_TOP_CLIENTS_TABLE: "tblsettings_ad_usage_top_clients",
  SITES_TABLE: "tblsettings_sites"
};

export const LOGS_TABLE_DEFAULT_TGL = ["Octets"];

export const RECOMMENDATION_TABLE_DEFAULT_TGL = [];

export const APPLICATION_TABLE_DEFAULT_TGL = [];

export const REPORT_TABLE_DEFAULT_TGL = [];

export const AD_USAGE_APPLICATION_TABLE_DEFAULT_TGL = [];

export const AD_USAGE_ANOMALY_SUMMARY_TABLE_DEFAULT_TGL = [];

export const AD_SITES_TABLE_DEFAULT_TGL = [];

export const AD_SINGLE_SITE_TABLE_DEFAULT_TGL = [];

export const AD_USAGE_CIRCUITS_AVAILABILITY_TABLE_DEFAULT_TGL = [];

export const AD_USAGE_TOP_CLIENTS_TABLE_DEFAULT_TGL = [];

export const SITES_TABLE_DEFAULT_TGL = [];

export const REPORT_NAMES = {
  REPORT_LINK_SLA: "linksla",
  REPORT_LINK_UTILIZATION: "linkutilization",
  REPORT_LINK_AVAILABILITY: "linkavailability",
  REPORT_LINK_UTILIZATION_BANDWIDTH: "linkutilizationbandwidth"
};
